import { flatten, length, map, pipe, prop } from 'rambda';
import { AuscultationTagsDTO } from '@higo/api/lib/models/auscultationTagsDTO';

export const countSelectedAuscultationTags: (
  tags: AuscultationTagsDTO[],
) => number = pipe(map(prop('tags')), flatten, length);
